import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=5f49ac95&scoped=true"
import script from "./insert.vue?vue&type=script&lang=js"
export * from "./insert.vue?vue&type=script&lang=js"
import style0 from "./insert.vue?vue&type=style&index=0&id=5f49ac95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49ac95",
  null
  
)

export default component.exports